<template>
  <section>
    <b-row>
      <b-col md="12">
        <b-col v-if="estadoQr == 0">
          <b-row class="mb-4">
            <h3>Registro de salida</h3>
            <b-col class="d-flex flex-row-reverse">
              <b-button class="ml-3" variant="primary" @click="decodificadoBoton">Registrar con codigo</b-button>
              <b-form-input id="codigo" v-model="codigoTexto" trim></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <qrcode-stream @decode="decodificado"></qrcode-stream>
          </b-row>
        </b-col>
        <!-- Error -->
        <div v-else>
          <b-row>
            <b-col>
              <h3>Registro de Salida</h3>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <!-- Acceso permitido o denegado (lateral) -->
            <b-col class="d-flex flex-column align-items-center justify-content-center">

              <h5 v-if="estadoQr == 1">El registro de salida ha sido exitoso</h5>
              <h5 v-if="estadoQr == 2">Creando registro de salida</h5>
              <h5 v-if="estadoQr == 3">El codigo QR no es valido o no se han encontrado el codigo en la base de datos</h5>
              <h5 v-if="estadoQr == 4">No se han ingresado datos</h5>

              <div class="mt-4 mb-5">

                <svg v-if="estadoQr == 1" width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-check-circle-fill" fill="#1BB55C" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>

                <svg v-else-if="estadoQr == 2" width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-hourglass-split" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0c0 .701.478 1.236 1.011 1.492A3.5 3.5 0 0 1 11.5 13s-.866-1.299-3-1.48V8.35z" />
                </svg>

                <svg v-else width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-x-octagon-fill" fill="#E74C3C" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zm-6.106 4.5a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                </svg>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-3 ">
            <b-col class="d-flex flex-column align-items-center justify-content-center">
              <b-button variant="primary" @click="reiniciarQr()">Escanear otro codigo</b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script lang="ts">
// Sin TypeScript

import axios from 'axios'
import { Vue, Component } from 'vue-property-decorator'
import { url } from '../../../services/url_service'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

@Component(
  {
    components: {
      QrcodeStream,
      QrcodeDropZone,
      QrcodeCapture,
    }
  }
)
export default class RegistroSalida extends Vue {
  public estadoQr: number = 0
  public codigoTexto: string = ''

  public decodificado(decodedString) {
    var ourJson, payload

    try {
      ourJson = JSON.parse(decodedString)
      payload = {
        codigo: ourJson['codigo'],
      }
      this.codigoTexto = payload.codigo
      this.validarDatos(this.codigoTexto)
    } catch (error) {
      this.estadoQr = 3
    }
  }

  public decodificadoBoton() {
    var codigoTexto = this.codigoTexto

    if (codigoTexto == null || codigoTexto == '') {
      this.estadoQr = 4
    } else {
      this.estadoQr = 2
      this.validarDatos(codigoTexto)
    }
  }

  public validarDatos(codigo) {
    if (codigo == null || codigo == '') {
      this.estadoQr = 4
    } else {
      try {
        this.registrarSalida()
      } catch (error) {
        this.estadoQr = 3
      }
    }
  }

  public async registrarSalida() {
    try {
      let response = await axios.post(
        url.create('/internal/ingreso/' + this.codigoTexto)
      )

      if (response.status != 200) {
        this.estadoQr = 3
      } else {
        if (response.data > 0) {
          this.estadoQr = 1
        } else {
          this.estadoQr = 3
        }
      }
    } catch (error) {
      this.estadoQr = 3
    }
  }

  public reiniciarQr() {
    this.estadoQr = 0
    this.codigoTexto = ''
  }

  // Cargar spiner mientras carga el componente
  public mounted() { }
}
</script>


<style lang="scss">
</style>